import { useNavigate } from 'react-router';
import { ClickableCard } from './components/clickable-card';
import { Icon } from '@/components/shared/icon';
import { type Plan } from '@/data/idp/plans/interfaces';

export const DraftPlanCard = ({ plan }: { plan: Plan }) => {
  const navigate = useNavigate();

  const recommendation = plan.profile_based_recommendation;
  const isBeingCreatedByAI = !!recommendation && !recommendation.completed_at;

  const handleNavigate = () => {
    navigate(`/pdi/planos/${isBeingCreatedByAI ? 'novo/' : ''}${plan.id}`);
  };

  return (
    <ClickableCard
      title={plan.title || 'Plano sem título'}
      subtitle="Rascunho em andamento"
      description="Você está quase lá! Clique para continuar a construção."
      onClick={handleNavigate}
      image={<Icon name="ruler-cross-pen" size={40} />}
    />
  );
};
